import { useContext } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Navigate } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
import { URLS } from "../shared/constants";

const DefaultLayout = () => {
  const auth = useContext(AuthContext);
  const { authState } = auth;
  const location = useLocation();

  const isPublicPath = location.pathname.includes("/public/");

  if (authState?.userInfo?.token && !isPublicPath) {
    return <Navigate replace to={URLS.DASHBOARD} />;
  }

  return (
    <>
      <Outlet />
    </>
  );
};

export default DefaultLayout;
